import { useEffect, useState } from "react"
import { toast } from "react-toastify"
import { useNavigate, useSearchParams } from "react-router-dom"


import Layout from "../../layouts/layout"
import MainPageLayout from "../../components/main-page-layout/mainPageLayout"
import Loading from "../../components/loading/loading"
// import WorkshopCard from "../../components/workshop-card/workshopCard"


import { ReactComponent as Edit } from "../../assets/icons/generals/Edit.svg"
import { ReactComponent as Delete } from "../../assets/icons/generals/Delete.svg"
import { ReactComponent as Filter } from "../../assets/icons/shapes/filter.svg"
import { useRequestProcessor } from "../../api/requestProcessor"
import { deleteSingleWorkshop, getAllWorkshops } from "../../api/workshops"
import { confirmAlert } from "react-confirm-alert"
import Pagination from "../../components/pagination/pagination"
import { domainName } from "../../constants/site"



const Workshops = () => {

    const naviagte = useNavigate()
    const [activeTab, setActiveTab] = useState(0)
    const [searchKeyword, setSearchKeyword] = useState("")
    const [page, setPage] = useState(1)




    async function onDeleteHandler(data, type) {
        confirmAlert({
            overlayClassName: "modalBackDrop-bg",
            customUI: ({ onClose }) => {
                return (
                    <div className='bg-white wsm:w-full w-[750px] py-8 px-4 rounded-xl font-bold'>
                        <h1 className=" text-center pb-4">
                            {"آیا از حذف " + type + " " + data.title + " مطمعن هستید؟"}
                        </h1>
                        <div className="flex justify-around ">

                            <button className="" onClick={onClose}>خیر</button>
                            <button className="border-2 text-red-500 rounded-lg py-3 !px-5 border-red-500"
                                onClick={() => { deleteMutate(data.id); onClose() }}>
                                بله
                            </button>
                        </div>
                    </div>
                );
            }
        })
    }





    const { Query, Mutate } = useRequestProcessor()

    const { data, isLoading, isError, refetch } = Query(
        ['getAllWorkshops', searchKeyword, page],
        () => getAllWorkshops(searchKeyword, page),
        { enabled: Boolean(searchKeyword) || searchKeyword == "" }
    );
    const { mutate: deleteMutate } = Mutate(
        "deleteWorkshop",
        deleteSingleWorkshop,
        {
            onSuccess: (data) => {
                toast.success(data.message)//This is the response you get back
                refetch()
            }
            ,
            onError: (data) => {
                toast.error(data.response.data.message)
            }
        }
    );


    const handlePageClick = (event) => {
        setPage(event.selected + 1);
    };

    return (
        <Layout>
            <MainPageLayout title={"ورک شاپ ها"} buttonTitle={"ورک شاپ جدید"} buttonLink={"/admin/workshop/create"}
            // customClass={"!grid !grid-cols-4 !gap-y-8 !gap-x-6 min-h-full wsm:!grid-cols-2"}
            >
                <div className="flex justify-between py-3 items-center  wsm:flex-col-reverse">
                    <div className="flex [&>*]:px-4 [&>*]:py-1 p-2 bg-[#eef3f7] rounded-lg text-[#5e6278]">
                        <button onClick={() => setActiveTab(0)} className={activeTab === 0 ? "bg-white rounded-lg text-black" : ""}>همه</button>
                        {/* <button onClick={() => setActiveTab(1)} className={activeTab === 1 ? "bg-white rounded-lg text-black" : ""}>جدید ترین</button>
                        <button onClick={() => setActiveTab(2)} className={activeTab === 2 ? "bg-white rounded-lg text-black" : ""}>قدیمی ترین</button> */}
                    </div>
                    <div className="flex wsm:mb-4">

                        <input type="text" className='form-input !w-full' value={searchKeyword}
                            onChange={(e) => setSearchKeyword(e.target.value)}
                            placeholder='جستوجو ورک شاپ ها ...' />

                        <span className="flex text-sky-500 font-serif items-center mr-3 cursor-pointer">
                            <Filter width={24} height={24} />
                            فیلتر
                        </span>
                    </div>
                </div>
                <table className="table-auto transition-all" >
                    <thead className="!py-2">
                        <tr className=" border-b border-black">
                            <th className="py-3">#</th>
                            <th className="py-3">بنر</th>
                            <th className="py-3">عنوان</th>
                            <th className="py-3">محل برگزاری</th>
                            <th className="py-3">زمان برگزاری</th>
                            <th className="py-3">ظرفیت</th>
                            <th className="py-3">تعداد شرکت کنندگان</th>
                            <th className="py-3">قیمت</th>
                            <th className="py-3">عملیات</th>
                        </tr>
                    </thead>
                    {
                        !isLoading &&
                        <tbody>
                            {
                                data?.data?.length ?
                                    data?.data?.map(el => (
                                        <tr key={el.id} className="text-[#575757] border-b border-[#d5d5d5] hover:bg-[#fafafa]"  >
                                            <td className="text-center py-5" >{el.id}</td>
                                            <td className="text-center py-5 flex justify-center" >
                                                <img
                                                    src={(() => {
                                                        const banner = el?.files?.find((f) => f.type === "banner")
                                                            || el?.files?.find((f) => f.type === "cover");
                                                        return banner?.file?.thumb ? domainName + banner.file.thumb : undefined;
                                                    })()}
                                                    className="max-h-[100px]"
                                                    alt={el.title}
                                                    width={150}
                                                />
                                            </td>
                                            <td className="text-center py-5" > {el.title}</td>
                                            <td className="text-center py-5" >{el.city?.name}</td>
                                            <td className="text-center py-5" >
                                                <p>{el.event_time?.split(" ")[0]}</p>
                                                <p>{el.event_time?.split(" ")[1]}</p>
                                            </td>
                                            <td className="text-center py-5" >{el.capacity}</td>
                                            <td className="text-center py-5" >{el.registration_number}</td>
                                            <td className="text-center py-5" >{el.price + " تومان"}</td>
                                            <td className="text-center py-5" >
                                                <div className="flex justify-between items-center">
                                                    {/* <div>view</div> */}
                                                    <div className=" cursor-pointer" onClick={() => naviagte("/admin/workshop/edit/" + el.id)}>
                                                        <Edit width={"16"} height="16" />
                                                    </div>
                                                    <div className=" cursor-pointer" onClick={() => { onDeleteHandler(el, "ورک شاپ") }}><Delete width={"20"} height="20" /></div>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                    :
                                    <div>
                                        <p>هیچ ورک شاپی پیدا نشد</p>
                                    </div>
                            }
                        </tbody>
                    }
                </table>
                {
                    isLoading && <Loading />
                }
                {data?.meta?.last_page > 1 && <Pagination handlePageClick={handlePageClick} lastPage={data?.meta?.last_page} />}


            </MainPageLayout>
        </Layout>
    )
}

export default Workshops